"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M15.904 16.8H8.096a.896.896 0 01-.896-.896V8.096c0-.495.401-.896.896-.896h7.808c.495 0 .896.401.896.896v7.808a.896.896 0 01-.896.896zm-7.256-4.32h3.832v-.96H8.648v.96zm6.232-3.36H8.648v.96h6.232v-.96zm0 4.8H8.648v.96h6.232v-.96z" }), "Details");
//# sourceMappingURL=Details.js.map